"use strict";
/*******************************************************************************

    The class that defines the Height.

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Height = void 0;
var Utils_1 = require("../utils/Utils");
var VarInt_1 = require("../utils/VarInt");
var Hash_1 = require("./Hash");
var jsbi_1 = __importDefault(require("jsbi"));
/**
 * The class that defines the Height.
 */
var Height = /** @class */ (function () {
    /**
     * Construct
     * @param value The block height
     */
    function Height(value) {
        this.value = jsbi_1.default.BigInt(value);
    }
    /**
     * Collects data to create a hash.
     * @param buffer The buffer where collected data is stored
     */
    Height.prototype.computeHash = function (buffer) {
        Hash_1.hashPart(this.value, buffer);
    };
    /**
     * Writes to the string
     * @param value The height of the block
     */
    Height.prototype.fromString = function (value) {
        this.value = jsbi_1.default.BigInt(value);
    };
    /**
     * Writes to the string
     */
    Height.prototype.toString = function () {
        return this.value.toString();
    };
    /**
     * Converts this object to its JSON representation
     *
     * Use `string` as primitive types, as JS is only precise up to
     * `2 ** 53 - 1` but we can get numbers up to `2 ** 64 - 1`.
     */
    Height.prototype.toJSON = function () {
        return this.toString();
    };
    /**
     * Serialize as binary data.
     * @param buffer - The buffer where serialized data is stored
     */
    Height.prototype.serialize = function (buffer) {
        VarInt_1.VarInt.fromJSBI(this.value, buffer);
    };
    /**
     * Deserialize as binary data.
     * @param buffer - The buffer to be deserialized
     */
    Height.deserialize = function (buffer) {
        return new Height(VarInt_1.VarInt.toJSBI(buffer));
    };
    /**
     * Creates and returns a copy of this object.
     */
    Height.prototype.clone = function () {
        return new Height(this.value);
    };
    /**
     * Returns the data size.
     */
    Height.prototype.getNumberOfBytes = function () {
        return Utils_1.Utils.SIZE_OF_LONG;
    };
    return Height;
}());
exports.Height = Height;
//# sourceMappingURL=Height.js.map